import { Field, Onboarding } from '@ofself/shell';
import './AccountFrame.css';

// THE ACCOUNT PAGES' FRAME — joining, signing in, resetting a password,
// signing a Mac or an iPhone in: every full-screen account page stands on the
// shell's <Onboarding> surface (owner call 2026-10-04: "make this the source
// of truth for all forms"): the desk, the faded ofself S behind, loud flush
// fields, the dashed foot. The page's steps are <Onboarding.Step>s inside it.
// Forms inside a page (settings, a dashboard) keep the kit's <Forms>.
function AccountFrame({ stages, label = 'ofSelf', className = '', children, ...rest }) {
  return (
    <Field>
      <Onboarding stages={stages} label={label} className={`account-frame ${className}`.trim()} {...rest}>
        {children}
      </Onboarding>
    </Field>
  );
}

/**
 * WHERE THIS IS GOING: the app that sent the person here (joinFlow's
 * appForNext, read from the shell's registry), as one quiet line. One template for every app in the registry, so the way into any of
 * them reads the same; nothing at all when nothing sent them.
 */
export function AppLine({ app, children }) {
  if (!app) return null;
  return (
    <p className="account-app">{children}</p>
  );
}

export default AccountFrame;
